import React from "react";
import { Button, Typography, Modal, Fade, Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ReactComponent as CloseIcon } from "../../../assets/icons/icon_close.svg";
import { isMobileDevice } from "../../../utils/Reusables";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #fff',
        boxShadow: '0px 0px 4px #0000001A',
        padding: '0rem',
        minWidth: '700px',
        maxWidth: '700px',
        borderRadius: '4px',
        // textAlign: 'center',
        boxShadow: '0px 0px 4px #0000001A',
        position: 'relative',
    },
    modalTitle: {
        fontSize: '18px',
    }
}));

export default function ChartEnlargeView(props) {
    const classes = useStyles();
    let { openPopup, ChartComponent, handleClose, reportName, classNames } = props;
    const [orientation, setOrientation] = React.useState('portrait');

    React.useEffect(() => {
        orientationSetup();
        window.addEventListener('resize', orientationSetup);
    }, []);

    const orientationSetup = () => {
        let mode = "portrait";
        if(window.innerWidth < 1024 && isMobileDevice()){
            mode = (window.screen.availWidth < window.screen.availHeight) ? "landscape" : "portrait";
        }
        setOrientation(mode);
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openPopup}
            onClose={() => {return false}}
            closeAfterTransition
        >
            <Fade in={openPopup} id="enlarge-modal">
                <Box className={classes.modalPaper + " " + (classNames ? classNames : " modal-box modal-full modal-report ") + " " + orientation} >
                    <Box className="modal-header" >
                        <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title folder-modal-title"} >{reportName}</Typography>
                        <CloseIcon onClick={handleClose} className="enlarge-close" />
                    </Box>
                    <Box className="modal-content-enlarge-view">
                        <div className={`published-modal-body ` + props?.chartType + (props?.chartIsFiltersType ? ` is-filters-type ` : ``)}>
                            {ChartComponent}
                        </div>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}
